<template>
  <path v-if="region && zoom" :d="pathString"
        :class="[{'is-active': active, 'is-lit': isLit, 'is-disabled' : isDisabled }, statusClass]"
        stroke-width="0"
        @click="onClick"
        @mouseover="onMouseMove"
        @touchstart="onMouseMove"
        @touchend="onMouseLeave"
        @mouseout="onMouseLeave" href="#"/>
</template>

<script>
  export default {
    name: 'MapRegion',
    props: ['region', 'zoom', 'active', 'lit', 'map'],
    data () {
      return {}
    },
    created () {
    },
    computed: {
      isDisabled () {
        if (!this.region.object) {
          return false
        }
        const object = this.$store.getters.getObject(+this.region.object.id)
        return object.disabled
      },
      isLit () {
        if (!this.region.object) {
          return false
        }
        const object = this.$store.getters.getObject(+this.region.object.id)
        return object.lit
      },
      statusClass () {
        if (this.map.type === 'Objects') {
          return this.region.object ? 'status-' + this.region.object.status : ''
        } else if (this.map.type === 'Maps') {
          return ''
        }
      },
      pathString () {
        const area = this.region
        const points = area.coords

        if (!points.length) {
          return ''
        }

        let first = points[0]
        let last = points[points.length - 1]

        let path = 'M' + (first[0] * this.zoom) + ',' + (first[1] * this.zoom)

        points.forEach(point => {
          path += 'L' + (point[0] * this.zoom) + ',' + (point[1] * this.zoom)
        })

        path += 'M' + first[0] * this.zoom + ',' + first[1] * this.zoom + 'L' + last[0] * this.zoom + ',' + last[1] * this.zoom

        this.path = path + 'Z'

        return path + 'Z'
      }
    },
    methods: {
      onClick () {
        this.$emit('click')
      },
      onMouseMove (e) {
        this.$emit('mousemove', this.region, e)
      },
      onMouseLeave (e) {
        this.$emit('mouseleave', this.region, e)
      }
    }
  }
</script>

<style scoped lang="scss">
  path {
    fill: transparent;
    transition: fill .3s;
    cursor: pointer;
    position: relative;
    pointer-events: all;
    outline: none;

    &:hover,
    &.is-active,
    &.is-lit {
      fill: rgba(#000, 9);
      outline: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/MapRegion.vue